<!-- src/views/new-tip/CampaignsList.vue -->
<template>
  <v-container fluid>
    <div class="d-flex align-center mb-4">
      <h1 class="text-h5 font-weight-medium">Campagnes New TIP</h1>
      <v-spacer />
      <v-btn color="primary" :to="{ name: 'new-tip.campaigns.create' }">
        <v-icon left>mdi-plus</v-icon>
        Nouvelle campagne
      </v-btn>
    </div>

    <v-card outlined>
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="search" label="Rechercher" prepend-inner-icon="mdi-magnify"
              dense hide-details clearable @input="onSearchInput"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="status" :items="statusItems" label="Statut" dense hide-details clearable
              @change="reload"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="campaigns"
        :loading="loading"
        :server-items-length="meta.total"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
        @update:options="onOptionsChange"
      >
        <template #item.name="{ item }">
          <router-link :to="{ name: 'new-tip.campaigns.show', params: { id: item.id } }" class="text-decoration-none">
            <strong>{{ item.name }}</strong>
          </router-link>
          <div class="text-caption grey--text" v-if="item.description">
            {{ item.description.substring(0, 80) }}{{ item.description.length > 80 ? '…' : '' }}
          </div>
        </template>

        <template #item.period="{ item }">
          {{ formatDate(item.start_date) }} → {{ formatDate(item.end_date) }}
        </template>

        <template #item.assignments_count="{ item }">
          <v-chip x-small label outlined>{{ item.assignments_count || 0 }}</v-chip>
        </template>

        <template #item.visits_count="{ item }">
          <v-chip x-small label outlined>{{ item.visits_count || 0 }}</v-chip>
        </template>

        <template #item.status="{ item }">
          <new-tip-status-badge type="campaign" :value="item.status" />
        </template>

        <template #item.actions="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon small v-on="on" :to="{ name: 'new-tip.campaigns.show', params: { id: item.id } }">
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Voir</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon small v-on="on" :to="{ name: 'new-tip.campaigns.assignments', params: { id: item.id } }">
                <v-icon small>mdi-account-multiple</v-icon>
              </v-btn>
            </template>
            <span>Affectations</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon small v-on="on" :to="{ name: 'new-tip.campaigns.edit', params: { id: item.id } }">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifier</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { CAMPAIGN_STATUSES } from '@/constants/newTip';
import { formatDate } from '@/helpers/formatters';
import StatusBadge from '@/components/new-tip/StatusBadge.vue';

export default {
  name: 'NewTipCampaignsList',
  components: { 'new-tip-status-badge': StatusBadge },
  data() {
    return {
      search: '',
      status: null,
      options: { page: 1, itemsPerPage: 20 },
      headers: [
        { text: 'Nom', value: 'name' },
        { text: 'Période', value: 'period', sortable: false },
        { text: 'Affectations', value: 'assignments_count', align: 'center', sortable: false },
        { text: 'Visites', value: 'visits_count', align: 'center', sortable: false },
        { text: 'Statut', value: 'status', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'right', width: 140 },
      ],
      statusItems: CAMPAIGN_STATUSES.map(s => ({ value: s.value, text: s.label })),
      searchTimeout: null,
    };
  },
  computed: {
    ...mapState('newTip', {
      campaigns: s => s.campaigns,
      meta: s => s.campaignsMeta,
    }),
    loading() { return this.$store.getters['newTip/isLoading']('campaigns'); },
  },
  methods: {
    ...mapActions('newTip', ['fetchCampaigns']),
    formatDate,
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.reload(), 350);
    },
    onOptionsChange() { this.reload(); },
    reload() {
      this.fetchCampaigns({
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        search: this.search || undefined,
        status: this.status || undefined,
      });
    },
  },
  mounted() { this.reload(); },
};
</script>
